import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  type DeclinedTransactionReasonEnum,
  DeclinedTransactionReasons,
} from '../../entities/enums/DeclinedTransactionReasonEnum'

export const useFormatDeclinedTransactionReason = () => {
  const intl = useProcurifyIntl()

  return (reason: DeclinedTransactionReasonEnum) => {
    switch (reason) {
      case DeclinedTransactionReasons.INSUFFICIENT_FUNDS:
        return intl.formatMessage(messages.reasonInsufficientFunds)
      case DeclinedTransactionReasons.UNSUPPORTED_CURRENCY:
        return intl.formatMessage(messages.reasonUnsupportedCurrency)
      case DeclinedTransactionReasons.FOREIGN_VENDOR:
        return intl.formatMessage(messages.reasonForeignVendor)
      case DeclinedTransactionReasons.LOCKED_CARD:
        return intl.formatMessage(messages.reasonLockedCard)
      case DeclinedTransactionReasons.CANCELED_CARD:
        return intl.formatMessage(messages.reasonCanceledCard)
      case DeclinedTransactionReasons.VERIFICATION_FAILED:
        return intl.formatMessage(messages.reasonVerificationFailed)
      case DeclinedTransactionReasons.SUSPECTED_FRAUD:
        return intl.formatMessage(messages.reasonSuspectedFraud)
      case DeclinedTransactionReasons.ACCOUNT_INVALID:
        return intl.formatMessage(messages.reasonAccountInvalid)
      case DeclinedTransactionReasons.CARD_LOST_STOLEN:
        return intl.formatMessage(messages.reasonCardLostStolen)
      case DeclinedTransactionReasons.CARD_NOT_ACTIVATED:
        return intl.formatMessage(messages.reasonCardNotActivated)
      case DeclinedTransactionReasons.RESTRICTED_COUNTRY:
        return intl.formatMessage(messages.reasonRestrictedCountry)
      case DeclinedTransactionReasons.CURRENCY_NOT_ALLOWED:
        return intl.formatMessage(messages.reasonCurrencyNotAllowed)
      case DeclinedTransactionReasons.NOT_SUPPORTED:
        return intl.formatMessage(messages.reasonNotSupported)
      case DeclinedTransactionReasons.TRANSACTION_BLOCKED_AT_TERMINAL:
        return intl.formatMessage(messages.reasonTransactionBlockedAtTerminal)
      case DeclinedTransactionReasons.TRANSACTION_BLOCKED:
        return intl.formatMessage(messages.reasonTransactionBlocked)
      case DeclinedTransactionReasons.OTHER:
      default:
        return intl.formatMessage(messages.reasonUnknown)
    }
  }
}
